import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { DoorOpen } from "lucide-react";
import { RiskPill } from "@/components/Badges";

export default function Rooms() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => { api.get("/rooms?scope=mine").then(({ data }) => setRooms(data)); }, []);

  return (
    <div className="min-h-screen warm-grain">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="font-display font-extrabold text-3xl">Your Help Rooms</h1>
        <p className="mt-2 text-muted-foreground">Rooms you started or joined. When people are inside, the door glows.</p>
        <div className="mt-6 grid gap-3">
          {rooms.length === 0
            ? <div className="border rounded-2xl bg-card p-6 text-sm text-muted-foreground" data-testid="rooms-empty">You haven't joined any Help Rooms yet.</div>
            : rooms.map((r) => (
              <Link key={r.room_id} to={`/room/${r.room_id}`} data-testid={`room-item-${r.room_id}`} className="border rounded-2xl bg-card p-4 flex items-center gap-4 hover:border-[color:hsl(var(--teal))]">
                <div className="w-10 h-10 rounded-xl grid place-items-center bg-[color:hsl(var(--amber))]/15 door-glow border border-[color:hsl(var(--amber))]/40">
                  <DoorOpen className="w-5 h-5 text-[color:hsl(var(--amber))]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-mono-label text-[color:hsl(var(--teal))]">{r.category} · {r.members?.length || 0} inside</div>
                  <div className="font-medium truncate">{r.title}</div>
                </div>
                <RiskPill risk={r.risk} />
              </Link>
            ))
          }
        </div>
      </div>
    </div>
  );
}
